import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { AccountMemberRole, CreateAccountInvitationInput } from '../../../generated/graphql';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { FormInput } from '../../../components/form-input';

interface InputInvitationDialogProps {
  onSubmit: (invitation: CreateAccountInvitationInput) => void;
  onClose: () => void;
  open: boolean;
}

interface FormValues {
  email: string;
  owner: boolean;
  manager: boolean;
}

export function InputInvitationDialog(props: InputInvitationDialogProps) {
  const { open, onClose, onSubmit } = props;
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: { email: '', owner: false, manager: false },
  });

  const onFormSubmit = (data: FormValues) => {
    if (!data.owner && !data.manager) {
      setError('owner', { message: 'Musíte vybrať aspoň jednu rolu.' });
      return;
    }
    const roles: AccountMemberRole[] = [];
    if (data.owner) roles.push('owner');
    if (data.manager) roles.push('manager');
    onSubmit({ email: data.email, roles });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle>Poznávka</DialogTitle>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <DialogContent>
          <Controller
            name="email"
            control={control}
            rules={{ required: true }}
            render={({ field }) => <FormInput label="Email" value={field.value} onChange={field.onChange} />}
          />
          <Controller
            name="owner"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox checked={field.value} onChange={(e) => field.onChange(e.target.checked)} />}
                label="vlastník"
              />
            )}
          />
          <Controller
            name="manager"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox checked={field.value} onChange={(e) => field.onChange(e.target.checked)} />}
                label="manažér"
              />
            )}
          />
          {errors.owner && (
            <Typography variant="body1" color="error">
              {errors.owner.message}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Zatvoriť</Button>
          <Button type="submit" variant="contained">
            Odoslať
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
